import 'shared/config/i18n';
import React, { Suspense } from 'react';
import { Loader } from '@kl/components-v6';
import { Outlet } from 'react-router-dom';
import { PluginRoot } from '../providers';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    #root {
        height: 100%;
    }
`;

export const App = () => (
    <Suspense fallback={<Loader centered size="large" />}>
        <GlobalStyles />
        <div
            data-plugin-version={process.env.REACT_APP_PLUGIN_VERSION}
            /** SC не правильно назначает классы при override стилей компонента. Создается и назначается класс такого же веса как и основной.
             * Если обернуть в styled component, то изменится порядок рендера компонент во всём вложенном дереве компонент и первым будет назначен класс с
             * переопределением стилей и после, класс основных стилей. В итоге, по правилам css, при равнозначном весе селектора - "кто последний тот папа"
             */
            style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
        >
            <PluginRoot>
                <Outlet />
            </PluginRoot>
        </div>
    </Suspense>
);
